var _defs, _style, _use, _use2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny-ps",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 41 41",
    width: 41,
    height: 41,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u65B0\u5EFA\u9879\u76EE") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 39,
    height: 27,
    id: "img1",
    href: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMzguMjE0IiBoZWlnaHQ9IjI2LjcwNyIgdmlld0JveD0iMCAwIDM4LjIxNCAyNi43MDciPgogIDxkZWZzPgogICAgPGxpbmVhckdyYWRpZW50IGlkPSJsaW5lYXItZ3JhZGllbnQiIHgxPSIwLjUiIHgyPSIwLjUiIHkyPSIxIiBncmFkaWVudFVuaXRzPSJvYmplY3RCb3VuZGluZ0JveCI+CiAgICAgIDxzdG9wIG9mZnNldD0iMCIgc3RvcC1jb2xvcj0iIzA5NDY3NCIvPgogICAgICA8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiMwNTIzM2EiLz4KICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgPC9kZWZzPgogIDxwYXRoIGlkPSJJY29uX3NpbXBsZS15b3V0dWJlIiBkYXRhLW5hbWU9Ikljb24gc2ltcGxlLXlvdXR1YmUiIGQ9Ik0zNy40MjMsOS41NDhBNC43OSw0Ljc5LDAsMCwwLDM0LjEsNi4yMjJjLTIuOTc5LS44LTE0Ljk2Ni0uOC0xNC45NjYtLjhzLTExLjk1Ny0uMDE2LTE0Ljk2Ni44QTQuNzksNC43OSwwLDAsMCwuODM5LDkuNTQ4YTQ5Ljc3MSw0OS43NzEsMCwwLDAtLjgzMSw5LjI0Niw0OS43NzEsNDkuNzcxLDAsMCwwLC44MzEsOS4yMTEsNC43OSw0Ljc5LDAsMCwwLDMuMzI2LDMuMzI2YzIuOTc1LjgsMTQuOTY2LjgsMTQuOTY2LjhzMTEuOTU2LDAsMTQuOTY2LS44YTQuNzksNC43OSwwLDAsMCwzLjMyNi0zLjMyNiw0OS43NzEsNDkuNzcxLDAsMCwwLC44LTkuMjExQTQ5Ljc3MSw0OS43NzEsMCwwLDAsMzcuNDIzLDkuNTQ4Wk0xNS4zLDI0LjUxNFYxMy4wNTdsOS45NzcsNS43MzdaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMC4wMDcgLTUuNDI0KSIgZmlsbD0idXJsKCNsaW5lYXItZ3JhZGllbnQpIi8+Cjwvc3ZnPgo="
  }), /*#__PURE__*/React.createElement("image", {
    width: 41,
    height: 41,
    id: "img2",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAAApAQMAAACSrpK1AAAAAXNSR0IB2cksfwAAAANQTFRFAAAAp3o92gAAAAF0Uk5TAEDm2GYAAAANSURBVHicY2AYBXgAAAEfAAGLuhk4AAAAAElFTkSuQmCC"
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\ttspan { white-space:pre }\n\t")), _use || (_use = /*#__PURE__*/React.createElement("use", {
    id: "youtube",
    href: "#img1",
    transform: "matrix(1,0,0,1,1,6)"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    id: "Background",
    href: "#img2",
    x: 0,
    y: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube1);
export default __webpack_public_path__ + "static/media/youtube1.26e075b27d374329ae8fe1d39cd9686a.svg";
export { ForwardRef as ReactComponent };